import { Injectable } from '@angular/core';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';

/**
 * OIDC Storage Provider.
 * Implements AbstractSecurityStorage using raw localStorage (no JSON wrapping).
 * Matches BackgroundSolutions' OidcCustomStorage pattern.
 *
 * The OIDC library handles its own serialization internally,
 * so we must NOT double-serialize with JSON.stringify/parse.
 */
@Injectable()
export class EIDCStoreProvider implements AbstractSecurityStorage {
  public read(key: string): string | null {
    return localStorage.getItem(key);
  }

  public write(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public remove(key: string): void {
    localStorage.removeItem(key);
  }

  public clear(): void {
    localStorage.clear();
  }
}
